import(/* webpackMode: "eager", webpackExports: ["Button"] */ "__barrel_optimize__?names=Button!=!/app/node_modules/antd/es/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/(dashboard)/category/[slug]/LatestNews/LatestNews.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/(dashboard)/category/[slug]/MainSection/MainSection.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/(dashboard)/category/[slug]/page.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/app/404.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/BreakingNewsMarquee/Marquee.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/commons/ImageContainer/ImageContainer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/HomePage/SubscribeBanner/SubscribeBanner.tsx");
